import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";

export default function HomeWhatOurCustomerSays() {
    return (
        <>

            <section className="eq-feedback-section ptb-120">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-12 col-lg-9">
                            <div className="section-title ps-sm-3 text-center">
                                <h2 className="text-eq-primary justify-content-center down-shadow">O que nossos clientes dizem?</h2>
                                {/*<p className="mb-3 fw-bold text-black">O Que Nossos Clientes Dizem?</p>
                                <p className="mb-0">Está em nosso DNA dar o melhor atendimento aos nossos clientes, gerando a melhor experiência de compra de veículos do mercado.</p>*/}
                            </div>
                        </div>
                    </div>
                    <div className="py-5 px-sm-3">
                        <Swiper
                            speed={3500}
                            loop={true}
                            slidesPerView={3}
                            spaceBetween={24}
                            autoplay={{
                                delay: 3500,
                                disableOnInteraction: false
                            }}
                            pagination={{
                                el: ".eq-feedback-pagination",
                                type: "bullets",
                                clickable: true
                            }}
                            breakpoints={{
                                [0]: { slidesPerView: 1 },
                                [768]: { slidesPerView: 2 },
                                [1200]: { slidesPerView: 3 }
                            }}
                            modules={[Pagination, Autoplay]}
                        >
                            <SwiperSlide className="size">
                                <div>
                                    <div className="info-comment">
                                        <div className="user-circle">
                                            <i className="fa-regular fa-user"></i>
                                        </div>
                                        <span>Adilson Batista</span>
                                    </div>
                                    {/*<span className="quote-icon align-items-center justify-content-center rounded-circle position-relative">
                                    <i className="fa-regular fa-user"></i>
                                </span>*/}
                                    <p className="mt-4 mb-3 fs-md">Acabei de conquistar o meu tão sonhado Carro e Graças a Deus escolhi a loja Certa.
                                        Agradeço muito a Império multimarcas e especialmente o Vendedor Felipe que foi Muito atencioso, ambiente atendimento e veículos Nota 10.</p>
                                    <div className="info-comment">
                                        <i className="fa-regular fa-heart"></i>
                                        <i className="fa-regular fa-comment"></i>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="size">
                                <div>
                                    <div className="info-comment">
                                        <div className="user-circle">
                                            <i className="fa-regular fa-user"></i>
                                        </div><span>Ana Felipe</span>
                                    </div>
                                    {/*<span className="quote-icon align-items-center justify-content-center rounded-circle position-relative">
                                    <i className="fa-regular fa-user"></i>
                                </span>*/}
                                    <p className="mt-4 mb-3 fs-md">Atendimento excelente, equipe atenciosa super recomendo pessoas sérias e comprometidas com a satisfação do cliente, recomendo para quem quiser conquistar o seu próximo veículo. Aqui fica meu agradecimento a vendedora Thayná uma excelente pessoa tanto que já é minha segunda compra com ela🤭☺️
                                    </p>
                                    <div className="info-comment">
                                        <i className="fa-regular fa-heart"></i>
                                        <i className="fa-regular fa-comment"></i>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="size">
                                <div>
                                    <div className="info-comment">
                                        <div className="user-circle">
                                            <i className="fa-regular fa-user"></i>
                                        </div><span>Mayara Padilha</span>
                                    </div>
                                    {/*<span className="quote-icon align-items-center justify-content-center rounded-circle position-relative">
                                    <i className="fa-regular fa-user"></i>
                                </span>*/}
                                    <p className="mt-4 mb-3 fs-md">Adorei! Vendedor Felipe, extremamente atencioso, nos deixa confortável na hora da escolha do Veículo, nos fornece a melhor proposta de pagamentos e financiamento nos trazendo segurança na hora da compra! Loja limpa e aconchegante!</p>
                                    <div className="info-comment">
                                        <i className="fa-regular fa-heart"></i>
                                        <i className="fa-regular fa-comment"></i>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </section>

        </>
    );
}